module.exports = __webpack_public_path__ + "img/Pic_Bottom_Pic.fde5124a.png";